import type { FaireProductEntity } from "../../entity_types/product";

export const p_8rum5u4ubq: FaireProductEntity = {
  token: "p_8rum5u4ubq",
  type: "product",
  name: "garden flowers assorted notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/6112ee678108bbeb6e876d5168e6c4850b4e8e65e2fbd35ba59c732c9b75113a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/510b9d44a23b80e654ca98dbb8dcc52dde25431e436ed0f3b2cd0d6868455acf.jpeg",
    "https://cdn.faire.com/fastly/185aaa0410f99e319695d30e071829dc9bd01bd03416895d31ce81415d876541.jpeg",
    "https://cdn.faire.com/fastly/606b763a9798b06448b1cef3ff651bf77ab6b6a118e56f944bda1ec5241d8919.jpeg",
  ],
  priceDollars: 8,
  description:
    'Send sweet greetings to your loved ones. The assorted set of garden flower notecards are blank on the inside with charming watercolor illustrations of a hydrangea, tulip, daisy, delphinium, garden rose, dahlia, daffodil, and violet on the front. They bring a touch of whimsical beauty to your thank-you notes, housewarming gifts, get-well wishes, and more.\n\nDetails:\n\n- set of eight folded cards + envelopes, one of each illustration\n- blank inside\n- 5.5" x 4.25"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:44.640Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
